import { motion } from "framer-motion";
import { Button } from "./ui/Button";

interface Props {
  submissionId: string;
  onReturn: () => void;
}

export function SubmissionStatus({ submissionId, onReturn }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      className="min-h-screen flex items-center justify-center px-4 py-10"
    >
      <div className="w-full max-w-2xl">
        <div className="relative overflow-hidden bg-status-active-bg border-2 border-status-active-border rounded-card p-8 shadow-card sm:p-12">
          <svg className="pointer-events-none absolute -bottom-12 -right-10 h-48 w-48 text-status-active-text opacity-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5-4.5A12 12 0 0112 3 12 12 0 014 5.5V11c0 5 3.4 9 8 10 4.6-1 8-5 8-10V5.5z" />
          </svg>
          <div className="relative z-10">
          <div className="w-20 h-20 rounded-card flex items-center justify-center mx-auto mb-6 bg-surface-raised border-2 border-status-active-border">
            <svg className="w-8 h-8 text-status-active-text" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <p className="mb-3 text-center text-xs font-extrabold uppercase tracking-[0.18em] text-status-active-text">Contract request received</p>
          <h2 className="font-display text-4xl font-extrabold tracking-[-0.045em] text-content-primary text-center mb-2">Thank you</h2>
          <p className="text-base leading-7 text-content-secondary text-center mb-8">
            Your contract request has been submitted. We will process it in the background and follow up if anything else is needed.
          </p>

          <p className="text-xs text-content-muted text-center mb-8 font-mono">
            ID: {submissionId.slice(0, 16)}…
          </p>

          <Button size="lg" onClick={onReturn} className="w-full">
            Return to contracts
          </Button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
